export default {
    designations: [],
    provinces: [],
    typeOrganisation: [],
    regionAdministrative: [],
    designationsContextChamp: [],
    desginationsContextExpertise: [],
    designationsContextPratique: []
}